import React from 'react'
import { BrowserRouter, Route, useHistory, useLocation, useParams } from 'react-router-dom'
import { LocalizationContext, LocalizationContextType } from '../shared/contexts'
import CatalogueProvider from './CatalogueProvider'
import CatalogueLayout from './CatalogueLayout'
import { OrderProvider } from './catalogueTypes'
import { CATEGORY_ROUTE, parseWorkspace } from './catalogueUrls'

interface CataloguePageProps {
  orderProviders: OrderProvider[]
}

const CataloguePage = ({ orderProviders }: CataloguePageProps) => {
  const { categoryId } = useParams<{ categoryId?: string }>()
  const location = useLocation()
  const history = useHistory()

  return (
    <CatalogueProvider
      categoryId={categoryId ? Number(categoryId) : null}
      workspace={parseWorkspace(location.search)}
      orderProviders={orderProviders}
      navigate={history.push}
    >
      <CatalogueLayout />
    </CatalogueProvider>
  )
}

interface ProductCatalogueAppProps {
  localization_context: LocalizationContextType
  orderProviders: OrderProvider[]
}

const ProductCatalogueApp = ({ localization_context, orderProviders }: ProductCatalogueAppProps) => (
  <LocalizationContext.Provider value={localization_context}>
    <BrowserRouter>
      <Route path={CATEGORY_ROUTE}>
        <CataloguePage orderProviders={orderProviders} />
      </Route>
    </BrowserRouter>
  </LocalizationContext.Provider>
)

export default ProductCatalogueApp
